import https from 'https';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

// https://stackoverflow.com/a/31090240
var code = 'try { return this === window; } catch (e) { return false; }';
var isBrowser = new Function(code)();
var requireNodeJS = function (name) {
    return function () {
        throw new Error(name + ' is only available in a nodejs environment');
    };
};
var btoa = isBrowser
    ? new Function('str', 'return window.btoa(str)')
    : new Function('str', "return Buffer.from(str).toString('base64')");
var atob = isBrowser
    ? new Function('str', 'return window.atob(str)')
    : new Function('str', "return Buffer.from(str, 'base64').toString('ascii')");
var parseBuffer = isBrowser
    ? requireNodeJS('parseBuffer')
    : new Function('str', 'return JSON.parse(Buffer.concat(str).toString())');
var randomBytes = isBrowser
    ? new Function('length', 'return Array.from(crypto.getRandomValues(new Uint8Array(length)))')
    : function (length) { return Array.from(require('crypto').randomBytes(length)); };
var getHostname = isBrowser
    ? new Function('str', 'return new URL(str).hostname')
    : function (str) { return require('url').parse(str).hostname; };

var DIGIT = '0123456789';
var SYMBL = '!@#$%^&*-+_=';
var LETTR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
var random = function (min, max, length) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 1; }
    if (length === void 0) { length = 1; }
    return randomBytes(length).map(function (byte) {
        return Math.floor((byte / 0x100) * (max - min + 1) + min);
    });
};
var shuffle = function (array) {
    var _a;
    var copy = __spread(array);
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = __read([copy[j], copy[i]], 2), copy[i] = _a[0], copy[j] = _a[1];
    }
    return copy;
};
var generateCharacter = function (characters, length) {
    return random(0, characters.length - 1, length).map(function (i) { return characters[i]; });
};
var generatePassword = function (length, digits, symbols) {
    if (length === void 0) { length = 16; }
    if (digits === void 0) { digits = 2; }
    if (symbols === void 0) { symbols = 2; }
    if (length < digits + symbols)
        return '';
    var lettr = generateCharacter(LETTR, length - digits - symbols);
    var digit = generateCharacter(DIGIT, digits);
    var symbl = generateCharacter(SYMBL, symbols);
    return shuffle(__spread(lettr, digit, symbl)).join('');
};

var AuthService = /** @class */ (function () {
    function AuthService(options) {
        var _this = this;
        this.user = {
            create: function (email, password, permissions) {
                var data = JSON.stringify({ email: email, password: password, permissions: permissions });
                return _this.userRequest('PUT', data);
            },
            update: function (data) {
                var _a;
                if (!!data.clientData)
                    data.clientData = (_a = {}, _a[_this.options.client_id] = data.clientData, _a);
                return _this.userRequest('PATCH', JSON.stringify(data));
            },
            delete: function (uid) {
                var data = JSON.stringify({ uid: uid });
                return _this.userRequest('DELETE', data);
            }
        };
        this.options = options;
    }
    /**
     * Construct a sign-in URL.
     * @param path Path to store as state
     */
    AuthService.prototype.createURL = function (path, base) {
        var _a = this.options, client_id = _a.client_id, endpoint = _a.endpoint;
        var redirect_uri = base
            ? base + new URL(this.options.redirect_uri).pathname
            : this.options.redirect_uri;
        var params = [
            'response_type=code',
            'client_id=' + client_id,
            'redirect_uri=' + redirect_uri,
            'state=' + encodeURIComponent(path || '/')
        ];
        return endpoint + '/oauth/authorize?' + params.join('&');
    };
    AuthService.prototype.generatePassword = function (length, digits, symbols) {
        return generatePassword(length, digits, symbols);
    };
    AuthService.prototype.getAuthToken = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, client_id, client_secret, endpoint, data, auth, options;
            return __generator(this, function (_b) {
                _a = this.options, client_id = _a.client_id, client_secret = _a.client_secret, endpoint = _a.endpoint;
                if (!client_secret)
                    throw new Error('This API requires a client_secret.');
                data = JSON.stringify({ grant_type: 'authorization_code', code: code });
                auth = 'Basic ' + btoa(client_id + ":" + client_secret);
                options = {
                    hostname: getHostname(endpoint),
                    path: '/api/token',
                    method: 'POST',
                    headers: {
                        Authorization: auth,
                        'Content-Type': 'application/json',
                        'Content-Length': '' + data.length
                    },
                    data: data
                };
                return [2 /*return*/, this.request(options).then(function (r) { return r.data; })];
            });
        });
    };
    AuthService.prototype.getIdToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var google_api_key, data, options;
            return __generator(this, function (_a) {
                google_api_key = this.options.google_api_key;
                if (!google_api_key)
                    throw new Error('This API requires a google API key.');
                data = JSON.stringify({ token: token, returnSecureToken: true });
                options = {
                    hostname: 'www.googleapis.com',
                    path: "/identitytoolkit/v3/relyingparty/verifyCustomToken?key=" + google_api_key,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Content-Length': '' + data.length
                    },
                    data: data
                };
                return [2 /*return*/, this.request(options).then(function (r) { return r.idToken; })];
            });
        });
    };
    AuthService.prototype.getToken = function (code) {
        var _this = this;
        return this.getAuthToken(code).then(function (token) { return _this.getIdToken(token); });
    };
    AuthService.prototype.getUser = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var project_id, user_id, options, fields, name, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        project_id = this.options.project_id;
                        if (!project_id)
                            throw new Error('This API requires a project_id.');
                        user_id = this.extractPayload(token).user_id;
                        options = {
                            hostname: 'firestore.googleapis.com',
                            path: "/v1/projects/" + project_id + "/databases/(default)/documents/user/" + user_id,
                            method: 'GET',
                            headers: { Authorization: 'Bearer ' + token }
                        };
                        return [4 /*yield*/, this.request(options)];
                    case 1:
                        fields = (_a.sent()).fields;
                        name = fields.name.mapValue.fields;
                        user = {
                            email: fields.email.stringValue,
                            name: {
                                first: name.first.stringValue,
                                last: name.last.stringValue
                            },
                            uid: user_id
                        };
                        if (fields.language)
                            user.language = fields.language.stringValue;
                        if (fields.phone)
                            user.phone = fields.phone.stringValue;
                        if (name.display)
                            user.name.display = name.display.stringValue;
                        if (name.middle)
                            user.name.middle = name.middle.stringValue;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    AuthService.prototype.getUserClaims = function (token) {
        var _a = this.extractPayload(token), developer = _a.developer, client = _a.client;
        return { developer: developer, client: client };
    };
    AuthService.prototype.extractPayload = function (token) {
        return JSON.parse(atob(token.split('.')[1]));
    };
    AuthService.prototype.userRequest = function (method, data) {
        var _a = this.options, client_id = _a.client_id, client_secret = _a.client_secret, endpoint = _a.endpoint;
        if (!client_secret)
            throw new Error('This API requires a client_secret.');
        var auth = 'Basic ' + btoa(client_id + ":" + client_secret);
        var options = {
            hostname: getHostname(endpoint),
            path: '/api/user',
            method: method,
            headers: {
                Authorization: auth,
                'Content-Type': 'application/json',
                'Content-Length': '' + data.length
            },
            data: data
        };
        return this.request(options).then(function (r) { return r.data; });
    };
    AuthService.prototype.request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (isBrowser)
                    return [2 /*return*/, this.fetch(options)];
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = https.request(options, function (response) {
                            var body = [];
                            response.on('data', function (chunk) { return body.push(chunk); });
                            response.on('end', function () {
                                try {
                                    var data = parseBuffer(body);
                                    var statusCode = response.statusCode;
                                    if (!statusCode || statusCode < 200 || statusCode >= 300)
                                        return reject(_this.parseError(data, statusCode));
                                    resolve(data);
                                }
                                catch (e) {
                                    reject(e);
                                }
                            });
                        });
                        if ('data' in options) {
                            if (typeof options.data === 'string')
                                request.write(options.data);
                            else
                                request.write(JSON.stringify(options.data));
                        }
                        request.on('error', reject);
                        request.end();
                    })];
            });
        });
    };
    AuthService.prototype.fetch = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, fetchOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://" + options.hostname + options.path;
                        fetchOptions = {
                            method: options.method,
                            headers: options.headers,
                            body: options.method === 'POST' ? JSON.stringify(options.data) : undefined
                        };
                        return [4 /*yield*/, window.fetch(url, fetchOptions)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    AuthService.prototype.parseError = function (error, statusCode) {
        var err = error.ok !== false
            ? { code: 'GOOGLE_CLOUD_ERROR', error: error.error.message }
            : error;
        var message = "[status-code " + statusCode + "] " + err.code + ": " + err.error;
        return new Error(message);
    };
    return AuthService;
}());

export { AuthService };
//# sourceMappingURL=index.mjs.map
